var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "error-404" }, [
      _c("img", {
        staticClass: "error-404-img",
        attrs: { src: "images/err-404.png" },
      }),
      _c("div", { staticClass: "error-404-text" }, [
        _vm._v("Страница не найдена."),
      ]),
      _c(
        "div",
        { staticClass: "error-404-link" },
        [
          _vm._v("Вернуться на "),
          _c("router-link", { attrs: { to: "/" } }, [_vm._v("Главную")]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }